var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#B2F6D6",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.5H25.5",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.8333V14.6667C10.5 15.3297 10.7634 15.9656 11.2322 16.4344C11.7011 16.9033 12.337 17.1667 13 17.1667C13.663 17.1667 14.2989 16.9033 14.7678 16.4344C15.2366 15.9656 15.5 15.3297 15.5 14.6667M10.5 13.8333H25.5M10.5 13.8333L12.1667 10.5H23.8333L25.5 13.8333M15.5 14.6667V13.8333M15.5 14.6667C15.5 15.3297 15.7634 15.9656 16.2322 16.4344C16.7011 16.9033 17.337 17.1667 18 17.1667C18.663 17.1667 19.2989 16.9033 19.7678 16.4344C20.2366 15.9656 20.5 15.3297 20.5 14.6667M20.5 14.6667V13.8333M20.5 14.6667C20.5 15.3297 20.7634 15.9656 21.2322 16.4344C21.7011 16.9033 22.337 17.1667 23 17.1667C23.663 17.1667 24.2989 16.9033 24.7678 16.4344C25.2366 15.9656 25.5 15.3297 25.5 14.6667V13.8333",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.168 25.5003V17.042",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.832 25.5003V17.042",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.5V22.1667C15.5 21.7246 15.6756 21.3007 15.9882 20.9882C16.3007 20.6756 16.7246 20.5 17.1667 20.5H18.8333C19.2754 20.5 19.6993 20.6756 20.0118 20.9882C20.3244 21.3007 20.5 21.7246 20.5 22.1667V25.5",
    stroke: "#00A85B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIco);
export default __webpack_public_path__ + "static/media/shop_ico.511177ab0e5dc10d674e9b4bf3abfbd9.svg";
export { ForwardRef as ReactComponent };